import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { appStore } from '../../app/AppStore';
import { addUrlWatchersToScopeForExplorer } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { MetricsSpaceOwnProps } from '../../app/spaces/MetricsSpace/MetricsSpace';
import {
  setURLParametersOrDefaultsForEnteringSpaceAndFetchContent,
} from '../../app/spaces/SpaceConfig/SiteSpaceConfigHelper';
import { MetricsSubspaceName, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { Telemetry } from '../services/TelemetryService';

export interface IMetricsSpaceScope extends ng.IScope {
  metricsSpaceProps: MetricsSpaceOwnProps;
}

export class MetricsSpaceCtrl {

  private currentPath: string;

  public static $inject = [
    '$location',
    '$scope',
    'BrowserTitleService',
    'TelemetryService',
    'AngularContextFactory',
    'subspace',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IMetricsSpaceScope,
    browserTitleService: BrowserTitleService,
    telemetryService: Telemetry,
    angularContextFactory: AngularContextFactory,
    subspace: MetricsSubspaceName,
  ) {
    browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.metricsBrowserTitle() });

    const angularContext = angularContextFactory.create($scope);

    $scope.metricsSpaceProps = {
      telemetry: telemetryService,
      angularContext,
    };

    // Must be done before any of the setting of sorts and defaults below
    appStore.dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'metric',
      subspaceName: subspace,
    }));

    const queryString = getQueryStringServiceFromAngular($location);
    this.currentPath = $location.path();
    const getPath = () => {
      return this.currentPath;
    };

    // need to reset all filters and sorts when entering the metrics space
    setURLParametersOrDefaultsForEnteringSpaceAndFetchContent(appStore, $location);
    addUrlWatchersToScopeForExplorer({ $scope, $location, queryString, store: appStore, getPreviousPath: getPath });
  }
}

Module.instance().controller('MetricsSpaceCtrl', MetricsSpaceCtrl);
